import { FIELD } from "./fieldKinds.js";
import { formatDateRange, formatLocation } from "../lib/format.js";
import { RSVP_REGISTRATION_FIELDS } from "../features/registration/formConfig.js";
import {
  compose, coverSection, aboutSection, gallerySection,
  rsvpSection, subscribeSection, closingSection,
} from "../features/brochure/sections.js";

// Anniversary celebration event type.
export default {
  id: "anniversary",
  category: "personal",
  label: "Anniversary",
  blurb: "Celebrate the years — story, gallery, RSVP.",
  icon: "💞",
  wizardSteps: [
    {
      id: "basics",
      title: "The essentials",
      fields: [
        { key: "title", label: "Couple / occasion", kind: FIELD.TEXT, required: true, placeholder: "Ravi & Anjali — 25 Years" },
        { key: "subtitle", label: "Tagline", kind: FIELD.TEXT, placeholder: "A silver jubilee celebration" },
        { key: "heroImage", label: "Hero photo", kind: FIELD.HERO_IMAGE, previewPage: "cover" },
      ],
    },
    {
      id: "when-where",
      title: "When & where",
      fields: [
        { key: "startDate", label: "Date", kind: FIELD.DATE, required: true },
        { key: "venue", label: "Venue", kind: FIELD.TEXT },
        { key: "city", label: "City", kind: FIELD.TEXT },
        { key: "mapsUrl", label: "Google Maps link", kind: FIELD.URL, placeholder: "https://maps.google.com/...", previewPage: "cover" },
      ],
    },
    {
      id: "story",
      title: "Story, hosts & RSVP",
      fields: [
        { key: "description", label: "Your story / invitation message", kind: FIELD.TEXTAREA, previewPage: "details" },
        { key: "registrationUrl", label: "External RSVP link (optional)", kind: FIELD.URL, previewPage: "cover" },
        {
          key: "collectEventRegistrations",
          label: "Collect RSVPs inside einvite",
          kind: FIELD.TOGGLE,
          previewPage: "eventRegistration",
          description: "Adds an RSVP form so guests can respond. Entries stay visible only to you.",
          defaultPatch: { eventRegistrationFields: RSVP_REGISTRATION_FIELDS.map((field) => ({ ...field })) },
        },
        {
          key: "eventRegistrationFields",
          label: "RSVP form builder",
          kind: FIELD.REGISTRATION_FIELDS,
          previewPage: "eventRegistration",
          showWhen: (details) => !!details.collectEventRegistrations,
        },
        { key: "contacts", label: "Host contacts", kind: FIELD.CONTACTS, previewPage: "closing" },
        {
          key: "collectPreRegistration",
          label: "Subscribe for updates",
          kind: FIELD.TOGGLE,
          previewPage: "subscribe",
          description: "A simple public form for guests to get updates by mobile or email.",
        },
      ],
    },
    {
      id: "gallery",
      title: "Gallery",
      fields: [
        { key: "customSlides", label: "Photo gallery", kind: FIELD.CUSTOM_SLIDES, previewPage: "customSlide" },
      ],
    },
  ],
  planPages(event) {
    const details = event.details || {};
    return compose(
      coverSection(event, { ctaLabel: "RSVP →" }),
      aboutSection(details, { heading: "Our Story" }),
      gallerySection(details),
      rsvpSection(event),
      subscribeSection(event),
      closingSection(details, { heading: "With love", ctaLabel: "RSVP →" }),
    );
  },
  deriveOg(details = {}) {
    const when = formatDateRange(details.startDate, details.endDate);
    const where = formatLocation(details);
    return {
      title: details.title || "An anniversary celebration",
      description: [details.subtitle, when, where].filter(Boolean).join(" · "),
    };
  },
};
